import { render, staticRenderFns } from "./Iframe.vue?vue&type=template&id=85cac684&scoped=true&"
import script from "./Iframe.vue?vue&type=script&lang=js&"
export * from "./Iframe.vue?vue&type=script&lang=js&"
import style0 from "./Iframe.vue?vue&type=style&index=0&id=85cac684&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85cac684",
  null
  
)

export default component.exports